// TODO map missing headers
export const getHeaderTitle = (location: string) => {
  switch (location) {
    case '/dashboard':
      return 'Dashboard';
    case '/assessments':
      return 'Assessment';
    case '/myactions':
      return 'myActions';
    case '/newsfeed':
      return 'Newsfeed';
    case '/learning':
      return 'LQA Learning Hub';
    case '/myaudit':
      return 'myAudit';
    case '/actionPlan':
      return 'Action Plan';
    default:
      return '';
  }
};
